import { useMemo } from 'react';
import { useUser } from '../utils/UserContext';
import { isPreActiveCustomer } from '../components/dashboard/customers/tabs/home/utils/demoData';
import { CustomerWithDriverOnboarding } from '../types/apiTypes';

/**
 * True when the signed-in customer is `pre_active` — approved, but not yet
 * fully onboarded.
 *
 * Pre-active customers get demo data across the dashboard rather than real
 * data, because most customer endpoints are active-only and reject them with a
 * 403. Screens that fetch have to opt out of fetching *and* substitute demo
 * data; see `MonthlyBudget` / `FinancialOverview` for the established shape.
 *
 * Existing screens each re-derive this from `useUser()`. This hook exists so
 * the accounting hub's five independent fetching hooks don't repeat the
 * derivation five times — new surfaces should prefer it over inlining.
 */
export function useIsPreActiveCustomer(): boolean {
  const { userRecord } = useUser();
  const status = (userRecord as CustomerWithDriverOnboarding | null)?.status;

  return useMemo(() => isPreActiveCustomer(status), [status]);
}
